import { useQuery } from "@apollo/client/react";
import moment from "moment";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { useState, useEffect } from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import toast from "react-hot-toast";
import { GET_DELEGACIONES_BOT } from "../../../data/graphQL/queries/ReporteBOT/getDelegacionesBOT";
import { adaptDelegacionesBOTArray } from "../../../adapters/delegacionesBOTAdapter";
import { adaptTiposReporteBOTArray } from "../../../adapters/tiposReporteBOTAdapter";
import { GET_TIPOS_REPORTE_BOT } from "../../../data/graphQL/queries/ReporteBOT/getTiposReporteBOT";
import { normalizeFilterValue } from "../../../helpers/tools";
import { fieldsToSearch } from "../constants/fieldsToSearch";

export const useGetFilters = () => {
    const [delegaciones, setDelegaciones] = useState([]);
    const [tiposReporte, setTiposReporte] = useState([]);

    const { filters, handleChangeFilters } = usePersistFilters({
        idDelegacion: 0,
        tipoReporte: '1',
        fechaDesde: moment().add(-5, 'd'),
        fechaHasta: moment(),
    }, `ReporteBOTFilters`);

    const { data: delegacionesData } = useQuery(GET_DELEGACIONES_BOT, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!delegacionesData) return;
        setDelegaciones(adaptDelegacionesBOTArray(delegacionesData.delegacionesBOT.valorEsperado));
        handleChangeFilters('idDelegacion', filters?.idDelegacion);
    }, [delegacionesData]);

    const { data: tiposReporteData } = useQuery(GET_TIPOS_REPORTE_BOT, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!tiposReporteData) return;
        setTiposReporte(adaptTiposReporteBOTArray(tiposReporteData.tiposReporteBOT.valorEsperado));
    }, [tiposReporteData]);

    return {
        filters,
        handleChangeFilters,
        delegaciones,
        tiposReporte,
    };
};